import { Directive, ElementRef, forwardRef, HostListener, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EventBus, EventBusBase } from '@skylab-angular-shared/core';
import { ValueAccessor } from './value-accessor';

@Directive({
    selector: 'ins-checkbox,ins-toggle',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BooleanValueAccessorDirective),
            multi: true,
        },
    ]
})
export class BooleanValueAccessorDirective extends ValueAccessor {

    public constructor(
        elm: ElementRef,
        @Inject(EventBus) eventBus: EventBusBase
    ) {
        super(elm, eventBus);
    }

    public override writeValue(value: any): void {
        this.elm.nativeElement.checked = this.currentValue = value == null ? false : value;
    }

    @HostListener('insChange', ['$event.target'])
    protected handleInputEvent(elm: any): void {
        this.handleChangeEvent(elm, elm.checked);
    }

    @HostListener('keyup', ['$event'])
    protected handleEnter(event: KeyboardEvent): void {
        if (event.code === 'Enter') {
            this.elm.nativeElement.checked = !this.elm.nativeElement.checked;
            this.handleInputEvent(event.target as HTMLInputElement);
        }
    }
}
